import { ZOOM_LEVELS } from '@/mapbox-layers';
import { TileConfig } from '@/models/tileConfig';

export interface AllSourceProperties {
  readonly promoteId?: string;
  readonly minZoom?: number;
  readonly maxZoom?: number;
  /** URL will be set from the tile config dynamically */
  url: string | null;
}

export type SourceType = Record<keyof TileConfig, AllSourceProperties | null>;

export const sourceConfig: SourceType = {
  clu: {
    maxZoom: 13,
    minZoom: 13,
    promoteId: 'uid',
    url: null,
  },
  counties: {
    maxZoom: 11,
    minZoom: 5,
    promoteId: 'GEOID',
    url: null,
  },
  'county-subdivisions': {
    maxZoom: ZOOM_LEVELS.TOWNSHIPS.MAX,
    minZoom: ZOOM_LEVELS.TOWNSHIPS.MIN,
    promoteId: 'GEOID',
    url: null,
  },
  'crop-history': null,
  flood: null,
  'parcel-centroids': {
    maxZoom: 13,
    minZoom: 13,
    promoteId: 'gid',
    url: null,
  },
  parcels: {
    maxZoom: 13,
    minZoom: 13,
    promoteId: 'gid',
    url: null,
  },
  sections: {
    maxZoom: ZOOM_LEVELS.SECTIONS.MAX,
    minZoom: ZOOM_LEVELS.SECTIONS.MIN,
    url: null,
  },
  states: {
    maxZoom: ZOOM_LEVELS.STATES.MAX,
    minZoom: ZOOM_LEVELS.STATES.MIN,
    promoteId: 'geoid',
    url: null,
  },
  'timber-mills': null,
  'timber-mills-north': null,
  'timber-mills-south': null,
  'timber-mills-west': null,
  townships: null,
  water: null,
};
